import materialService from 'ApiService/Student/materialService';
import Card from 'components/card';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { BallTriangle } from 'react-loader-spinner';
import { FiEye, FiExternalLink } from 'react-icons/fi';

const TrainingMaterialUrls = () => {
  const [urls, setUrls] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchUrls = async () => {
    try {
      setLoading(true);
      const response = await materialService.getTrainingMaterialUrls();
      if (response.data.success) {
        setUrls(response.data.data || []);
      } else {
        setUrls([]);
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          'Failed to fetch training material URLs.'
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUrls();
  }, []);

  return (
    <div className="mt-20 md:mt-10">
      <Card>
        <div className="mb-6">
          <h2 className="text-2xl font-bold text-navy-700 dark:text-white">
            Training Material URLs
          </h2>
          <p className="text-sm text-gray-500 dark:text-gray-400">
            View URLs assigned to your batch by teachers
          </p>
        </div>

        {loading ? (
          <div className="flex justify-center py-10">
            <BallTriangle color="#5431ed" />
          </div>
        ) : urls.length === 0 ? (
          <div className="py-10 text-center text-gray-500">
            No training material URLs assigned to your batch yet.
          </div>
        ) : (
          <div className="space-y-4">
            {urls.map((urlItem, index) => (
              <div
                key={urlItem._id || index}
                className="flex flex-col gap-4 rounded-lg border border-gray-200 bg-gray-50 p-4 dark:border-navy-700 dark:bg-navy-900 md:flex-row md:items-center md:justify-between"
              >
                <div className="flex-1">
                  <h3 className="text-lg font-semibold text-navy-700 dark:text-white">
                    {urlItem.title}
                  </h3>
                  {urlItem.description && (
                    <p className="mt-1 text-sm text-gray-600 dark:text-gray-300">
                      {urlItem.description}
                    </p>
                  )}
                  <p className="mt-2 text-xs text-gray-500">
                    Assigned on:{' '}
                    {new Date(urlItem.createdAt).toLocaleDateString()}
                  </p>
                </div>
                <a
                  href={urlItem.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 rounded-lg bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700"
                >
                  <FiExternalLink className="h-4 w-4" />
                  Open URL
                </a>
              </div>
            ))}
          </div>
        )}
      </Card>
    </div>
  );
};

export default TrainingMaterialUrls;
